import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import "./DropActionsStyle.css";
import Edit from "../../assets/svg/edit.png";

const DropActions = ({
  isActive,
  dropActionOptions,
}) => {
  const [isDropAction, setIsDropAction] = useState(isActive);
  const [menuStyle, setMenuStyle] = useState({});
  const anchorRef = useRef(null);
  const menuRef = useRef(null);

  useEffect(() => {
    setIsDropAction(isActive);
  }, [isActive]);

  // Position the portaled menu relative to the trigger cell.
  useLayoutEffect(() => {
    if (!isDropAction || !anchorRef.current) return;
    const positionMenu = () => {
      if (!anchorRef.current) return;
      // The anchor span sits next to the action button. Use the parent cell's
      // rect for a stable anchor independent of overflow:auto scroll containers.
      const triggerEl = anchorRef.current.parentElement || anchorRef.current;
      const rect = triggerEl.getBoundingClientRect();
      const menuWidth = 168;
      const menuHeightEst = (dropActionOptions?.length || 4) * 34 + 12;
      // Default: align menu's right edge to trigger's right edge, drops down
      let left = rect.right - menuWidth;
      let top = rect.bottom + 6;
      // Flip up if it would clip the bottom of the viewport
      if (top + menuHeightEst > window.innerHeight - 12) {
        top = Math.max(12, rect.top - menuHeightEst - 6);
      }
      // Keep within the viewport horizontally
      if (left < 12) left = 12;
      if (left + menuWidth > window.innerWidth - 12) {
        left = window.innerWidth - menuWidth - 12;
      }
      setMenuStyle({
        position: "fixed",
        top,
        left,
        minWidth: menuWidth,
      });
    };
    positionMenu();
    window.addEventListener("scroll", positionMenu, true);
    window.addEventListener("resize", positionMenu);
    return () => {
      window.removeEventListener("scroll", positionMenu, true);
      window.removeEventListener("resize", positionMenu);
    };
  }, [isDropAction, dropActionOptions]);

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        anchorRef.current &&
        !anchorRef.current.parentElement?.contains(event.target) &&
        menuRef.current &&
        !menuRef.current.contains(event.target)
      ) {
        setIsDropAction(false);
      }
    };
    if (isDropAction) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDropAction]);

  return (
    <>
      <span ref={anchorRef} className="dropActionAnchor" aria-hidden="true" />
      {isDropAction &&
        typeof document !== "undefined" &&
        ReactDOM.createPortal(
          <div
            ref={menuRef}
            className="dropActionWrap dropActionWrapPortal active"
            style={menuStyle}
          >
            <div className="dropActionMenu">
              {dropActionOptions?.length > 0 &&
                dropActionOptions.map((action, i) => (
                  <button
                    type="button"
                    className="actionList"
                    onClick={() => {
                      action?.onClick();
                      setIsDropAction(false);
                    }}
                    key={i}
                  >
                    <img src={action?.icon ?? Edit} alt="" />
                    {action?.label}
                  </button>
                ))}
            </div>
          </div>,
          document.body
        )}
    </>
  );
};

export default DropActions;
